export enum DeploymentVersionItemBlockType {
  Markdown = 'markdown',
  Image = 'image',
  Video = 'video',
}
